// @flow
import React from 'react';
import {
  compose,
  setDisplayName,
} from 'recompose';
import { ModalRoute } from '@team-griffin/redux-modal-router';
import {
  Modal,
} from '@ux/modal';
import { NegotiateModal } from './negotiate';
import { ModalRoute as ModalRouteC } from '../../core/constants';


const PureModalRoutes = ({
  theme,
  negotiate,
  currency,
}) => (
  <ModalRoute
    path={ModalRouteC.NEGOTIATE}
    // eslint-disable-next-line react/jsx-no-bind
    render={(modalProps) => (
      <Modal
        theme={theme}
        // eslint-disable-next-line react/jsx-handler-names
        onRequestClose={modalProps.closeModal}
        isOpen={true}
      >
        <NegotiateModal
          theme={theme}
          actions={modalProps}
          options={negotiate}
          currency={currency}
        />
      </Modal>
    )}
  />
);

const enhance = compose(
  setDisplayName('ModalRoutes'),
);

export default enhance(PureModalRoutes);
